import React from "react";
import styled from "styled-components";
import usePageRect from "./usePageRect";

const Styled = {
  Holder: styled.div`
    position: absolute;
    top: 0;
  `,
  Page: styled.div`
    position: absolute;
    overflow: hidden;
  `,
};

export default function PageAreaHolder({ children, className = "" }) {
  const rect = usePageRect();

  function getStyle() {
    return {
      transform: `translate(${rect.left}px,${rect.top}px)`,
      width: `${Math.round(rect.width)}px`,
      height: `${Math.round(rect.height)}px`,
    };
  }

  return (
    <Styled.Holder className={className}>
      <Styled.Page style={getStyle()}>{children}</Styled.Page>
    </Styled.Holder>
  );
}
